import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const CalendarWidget: WidgetRegistryEntry = {
  name: "Calendar",
  configuration: () => import("./configuration").then((m) => m.CalendarWidgetConfiguration),
  component: () => import("./calendar-widget.component").then((m) => m.CalendarWidgetComponent)
};
